import {useCallback, useMemo, useState} from 'react'

import {ExpandedRowsContext} from './use-expanded-rows'

export function ExpandedRowsProvider({children}: {children?: React.ReactNode}) {
  const [expandedRows, setExpandedRows] = useState<Array<string>>([])

  const toggleRowExpanded = useCallback((rowId: string) => {
    setExpandedRows(prevExpandedRows => {
      if (prevExpandedRows.includes(rowId)) {
        return prevExpandedRows.filter(id => id !== rowId)
      }
      return [...prevExpandedRows, rowId]
    })
  }, [])

  return (
    <ExpandedRowsContext.Provider
      value={useMemo(
        () => ({
          expandedRows,
          toggleRowExpanded,
        }),
        [expandedRows, toggleRowExpanded],
      )}
    >
      {children}
    </ExpandedRowsContext.Provider>
  )
}

try{ ExpandedRowsProvider.displayName ||= 'ExpandedRowsProvider' } catch {}